// single-account success (AeroPass returning user + AeroPass link-new-bank)
export interface WidgetEventSuccessType {
    connectionId: string;
    clientName: string;
    aeroPassUserUuid: string;
}

// one linked account in the multi-account success payload
export interface WidgetEventSuccessAccount {
    connectionId: string;
    accountType: string;
    accountNumberDisplay: string;
}

// multi-account success (enable_multiple_account_linking)
export interface WidgetEventMultiAccountSuccessType {
    accounts: WidgetEventSuccessAccount[];
    clientName: string;
    aeroPassUserUuid: string;
}

// onSuccess payload: single-account or multi-account
export type WidgetSuccessPayload =
    | WidgetEventSuccessType
    | WidgetEventMultiAccountSuccessType;

export interface WidgetEventType {
    payload: WidgetEventPayloadType;
    type: string;
}

export interface WidgetEventPayloadType {
    pageTitle: string;
    onLoadApi: string;
}

export interface WidgetEventBankClickType {
    type: string;
    stateCode: string;
}

export enum WidgetMessageEventType {
    ONERROR = 'widgetError',
    ONEVENT = 'widgetPageLoaded',
    ONSUCCESS = 'pageSuccess',
    ONCLOSE = 'widgetClose',
    ONBANKCLICK = 'widgetBankClick'
}

export interface WidgetMessageType {
    type: WidgetMessageEventType,
    payload: WidgetMessagePayloadType
}

type WidgetMessagePayloadType = WidgetEventType | WidgetSuccessPayload | WidgetEventPayloadType | WidgetEventBankClickType | string | object

